import React, { useCallback, useMemo, useState } from "react";
import PopupMultiSelectField from "./PopupMultiSelectField";
import useNominatimSearch from "../utils/useNominatimSearch";
import { normalizeLocationFilterValues } from "../utils/locationFilters";

/**
 * A drop-in replacement for PopupMultiSelectField for location fields.
 * Queries the Nominatim (OpenStreetMap) geocoding service as the user types
 * and merges the suggestions with any existing static options.
 * Results are formatted as "City, State, Country".
 */
export default function LocationMultiSelectField({
  options = [],
  searchExternal = true,
  loading = false,
  onChange,
  onInputValueChange,
  autocompleteProps,
  ...rest
}) {
  const [inputValue, setInputValue] = useState("");

  const { results: nominatimResults, loading: nominatimLoading } =
    useNominatimSearch(searchExternal ? inputValue : "");

  const mergedOptions = useMemo(() => {
    return normalizeLocationFilterValues([...options, ...(searchExternal ? nominatimResults : [])]);
  }, [options, nominatimResults, searchExternal]);

  const handleInputValueChange = useCallback(
    (val) => {
      setInputValue(val);
      onInputValueChange?.(val);
    },
    [onInputValueChange]
  );

  return (
    <PopupMultiSelectField
      {...rest}
      options={mergedOptions}
      loading={loading || nominatimLoading}
      onChange={onChange}
      onInputValueChange={handleInputValueChange}
      autocompleteProps={autocompleteProps}
    />
  );
}
